/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


const mutations = {


  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
    state.isVerticalNavMenuActive = value
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val
  },
  UPDATE_MAIN_LAYOUT_TYPE(state, val) {
    state.mainLayoutType = val
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
    state.verticalNavMenuItemsMin = val
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
    state.verticalNavMenuWidth = width
  },


  // VxAutoSuggest

  UPDATE_STARRED_PAGE(state, payload) {

    // find item index in search list state
    const index = state.navbarSearchAndPinList["pages"].data.findIndex((item) => item.url == payload.url)

    // update the main list
    state.navbarSearchAndPinList["pages"].data[index].is_bookmarked = payload.val

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(state.navbarSearchAndPinList["pages"].data[index])
    } else {
      // find item index from starred pages
      const index = state.starredPages.findIndex((item) => item.url == payload.url)

      // remove item using index
      state.starredPages.splice(index, 1)
    }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED(state, list) {
    const starredPagesMore = state.starredPages.slice(10)
    state.starredPages = list.concat(starredPagesMore)
  },
  ARRANGE_STARRED_PAGES_MORE(state, list) {
    let downToUp = false
    let lastItemInStarredLimited = state.starredPages[10]
    const starredPagesLimited = state.starredPages.slice(0, 10)
    state.starredPages = starredPagesLimited.concat(list)

    state.starredPages.slice(0, 10).map((i) => {
      if (list.indexOf(i) > -1) downToUp = true
    })

    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited)
    }
  },
  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////
  TOGGLE_CONTENT_OVERLAY(state, val) {
    state.bodyOverlay = val
  },
  UPDATE_PRIMARY_COLOR(state, val) {
    state.themePrimaryColor = val
  },
  UPDATE_THEME(state, val) {
    state.theme = val
  },
  UPDATE_WINDOW_WIDTH(state, width) {
    state.windowWidth = width
  },
  UPDATE_WINDOW_SCROLL_Y(state, val) {
    state.scrollY = val
  },
  // /////////////////////////////////////////////
  // User/Auth
  // /////////////////////////////////////////////
  FETCH_CURRENT_USER(state, payload) {
    // Get Data localStorage
    let user = JSON.parse(localStorage.getItem("user")) || state.user
    for (const property of Object.keys(payload)) {
      if (payload[property] != null) {
        // If some of user property is null - user default property defined in state.AppActiveUser
        state.user[property] = payload[property]
        // Update key in localStorage
        user[property] = payload[property]
      }
    }
    // Store data in localStorage
    localStorage.setItem("user", JSON.stringify(user))
  },
  // Get events
  FETCH_ALL_EVENTS(state, payload) {
    state.events = payload
  },
  // Create new event
  CREATE_EVENT(state, payload) {
    state.isEventCreated = payload
  },
  //get all events locations
  FETCH_ALL_LOCATIONS(state, payload) {
    state.locations = payload
  },
  // Create new location
  CREATE_LOCATION(state, payload) {
    state.isLocationCreated = payload
  },
  // update location
  UPDATE_LOCATION(state, payload) {
    const index = state.locations.findIndex(location => location.id === payload.id);
    if (index !== -1) {
      state.locations.splice(index, 1, payload);
    }
  },  
  FETCH_COUNT_RESERVATIONS(state, payload) {
    state.countUnconfirmedReservation = payload
  },
  FETCH_COUNT_EVENTS(state, payload) {
    state.countUpcomingEvents = payload
  },
  FETCH_COUNT_USERS(state, payload) {
    state.countUsers = payload
  },

  FETCH_FOOTER_INFO(state, payload) {
    state.footerInfo = payload
  },

  RESERVATIONS_BY_USER(state, payload) {
    state.reservationsByUser = payload
  },

  FETCH_PENDING_RESERVATIONS(state, payload) {
    state.pendingReservations = payload
  },
  FETCH_APPROVED_RESERVATIONS(state, payload) {
    state.approvedReservations = payload
  },
  FETCH_ALL_USERS(state, payload) {
    state.users = payload
  },
  FETCH_ALL_ADMINS(state, payload) {
    state.admins = payload
  },

  SET_SEARCH_STRING(state, payload) {
    state.search = payload
  },

  SET_SEARCH_ALL_STRING(state, payload) {
    state.searchAll = payload
  },
  FETCH_HOME_CONTENTS(state, payload) {
    state.contents = payload
  },
  FETCH_ALL_RESERVATIONS(state, payload) {
    state.allReservations = payload
  },
  SET_IS_LOADING(state, payload) {
    state.isLoading = payload
  },

  FETCH_ALL_PENDING_RESERVATIONS(state, payload) {
    state.allPendingReservations = payload
  },

  //Handle errors
  HANDLE_ERROR(state, payload) {
    state.isError = true
    state.errorMessage = payload
  }
}


export default mutations

